import { FieldError, FieldValues, Path, UseFormRegister } from "react-hook-form";

interface FormInputProps<T extends FieldValues> {
  label: string;
  name: Path<T>;
  register: UseFormRegister<T>;
  type?: "text" | "number" | "email" | "password" | "tel" | "url";
  placeholder?: string;
  error?: FieldError;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  errorClassName?: string;
  required?: boolean;
  uppercase?: boolean;
  step?: string;
  validate?: (value: any) => string | boolean | undefined;
}

export function FormInput<T extends FieldValues>({
  label,
  name,
  register,
  type = "text",
  placeholder = "",
  error,
  className = "formGroup",
  labelClassName = "cardHeading",
  errorClassName = "error",
  required = false,
  uppercase = false,
  step,
  validate,
}: FormInputProps<T>) {
  return (
    <div className={className}>
      <label className={labelClassName}>
        {label}
        {required && <span className="required">*</span>}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        className="formControl"
        step={step}
        {...register(name, {
          onChange: uppercase 
            ? (e: React.ChangeEvent<HTMLInputElement>) => {
                e.target.value = e.target.value.toUpperCase();
              }
            : undefined,
          validate: validate 
        })}
        {...(type === "number" && {
          onWheel: (e) => e.currentTarget.blur()
        })}
      />
      {error && <p className={errorClassName}>{error.message}</p>}
    </div>
  );
}